import { useEffect, useState } from "react";
import api from "../../../lib/api";
import { Save, Check, Eye, EyeOff } from "lucide-react";

const SECTIONS = [
  { key: "stats", label: "Statistiques", desc: "Bloc années d'expérience / clients" },
  { key: "services_preview", label: "Aperçu Services", desc: "Grille des 4 services sur la home" },
  { key: "about_preview", label: "Aperçu À propos", desc: "Bloc présentation photographe sur la home" },
  { key: "features", label: "Points forts", desc: "Section 'Ce qui nous rend uniques'" },
  { key: "testimonials", label: "Témoignages", desc: "Avis clients" },
  { key: "cta", label: "Bloc CTA final", desc: "Appel à action avant le footer" },
  { key: "booking_form", label: "Widget réservation (Contact)", desc: "Calendrier de réservation en bas de la page Contact" },
];

export default function VisibilityManager() {
  const [vis, setVis] = useState({});
  const [loading, setLoading] = useState(false);
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    api.get("/content/sections_visibility").then(({ data }) => setVis(data || {})).catch(() => setVis({}));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const toggle = (key) => setVis({ ...vis, [key]: !vis[key] });

  const save = async () => {
    setLoading(true);
    try {
      await api.put("/content/sections_visibility", { data: vis });
      setSaved(true);
      setTimeout(() => setSaved(false), 2200);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="visibility-manager">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h1 className="font-serif text-4xl">Affichage des sections</h1>
          <p className="text-[#4A3F35] mt-2">Activez ou désactivez les sections affichées sur la page d&apos;accueil.</p>
        </div>
        <button onClick={save} disabled={loading} className="btn-primary disabled:opacity-50" data-testid="visibility-save">
          {saved ? <><Check size={16} /> Enregistré</> : <><Save size={16} /> Enregistrer</>}
        </button>
      </div>

      <div className="bg-[#FDFBF7] rounded-2xl border border-[#2D2A26]/10 divide-y divide-[#2D2A26]/10">
        {SECTIONS.map((s) => {
          const active = vis[s.key];
          return (
            <div key={s.key} className="flex items-center justify-between p-5">
              <div className="flex items-start gap-4">
                <div className={`w-10 h-10 rounded-full flex items-center justify-center ${active ? "bg-[#8A9A86]/15 text-[#8A9A86]" : "bg-[#2D2A26]/5 text-[#2D2A26]/40"}`}>
                  {active ? <Eye size={18} /> : <EyeOff size={18} />}
                </div>
                <div>
                  <h3 className="font-serif text-xl">{s.label}</h3>
                  <p className="text-sm text-[#4A3F35]/70">{s.desc}</p>
                </div>
              </div>
              <button
                onClick={() => toggle(s.key)}
                className={`relative w-14 h-8 rounded-full transition ${active ? "bg-[#8A9A86]" : "bg-[#2D2A26]/15"}`}
                data-testid={`toggle-${s.key}`}
                aria-label={`Toggle ${s.label}`}
              >
                <span className={`absolute top-1 left-1 w-6 h-6 rounded-full bg-white shadow transition ${active ? "translate-x-6" : ""}`} />
              </button>
            </div>
          );
        })}
      </div>

      <p className="mt-6 text-sm text-[#4A3F35]/60">💡 Le Hero (bannière principale) est toujours affiché.</p>
    </div>
  );
}
